import { render } from "./othersComponent.vue?vue&type=template&id=aeae90da&scoped=true"
import script from "./othersComponent.vue?vue&type=script&lang=js"
export * from "./othersComponent.vue?vue&type=script&lang=js"

import "./othersComponent.vue?vue&type=style&index=0&id=aeae90da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeae90da"]])

export default __exports__